import { create } from 'zustand';
import type { InfraServiceStatus } from '../api/types';

const EMPTY_SERVICES: InfraServiceStatus[] = [];

type InfraState = {
  /** Latest status for each infrastructure service (Kafka, TimescaleDB, MongoDB, Redis). */
  services: InfraServiceStatus[];
  lastUpdateAt: number | null;
  setServices: (s: InfraServiceStatus[]) => void;
};

export const useInfraStore = create<InfraState>()((set) => ({
  services: EMPTY_SERVICES,
  lastUpdateAt: null,
  setServices: (services) =>
    set({
      services,
      lastUpdateAt: Date.now(),
    }),
}));
